import { createStore } from 'vuex'
import { defaultLang } from '@/config/lang'
import { getUser, setUser, getHistoryAccount, setHistoryAccount } from '@/utils'

export default createStore({
  state: {
    locale: defaultLang,
    cpUserInfo: getUser(),
    historyAccount: getHistoryAccount()
  },
  mutations: {
    SET_LOCALE(state, locale) {
      state.locale = locale
    },
    SET_CP_USER_INFO(state, cpUserInfo) {
      setUser(cpUserInfo)
      state.cpUserInfo = cpUserInfo
      if (cpUserInfo.cpUserId) {
        this.commit('SET_HISTORY_ACCOUNT', cpUserInfo)
      }
    },
    SET_HISTORY_ACCOUNT(state, cpUserInfo) {
      setHistoryAccount(cpUserInfo)
      state.historyAccount = getHistoryAccount()
    }
  },
  actions: {
  },
  modules: {
  }
})
